// extracted by mini-css-extract-plugin
export default {"base":"featured-policy-banner-module__base--nCy"};